import MuiCard, { CardProps } from '@mui/material/Card';

export interface ICardProps extends CardProps { }

const Card = (props: ICardProps): JSX.Element => {
  return <MuiCard {...props} sx={{ ...props.sx, m: 0, p: 0 }} />;
};

export default Card;
